import {DataSource, setMetadata} from '../core/data-source/data-source';
import {RestResponseRecord} from '../core/data-source/http-crud.data-source';
import {fromJson} from '../core/data-source/json.mapper';
import {httpService, IHttpRequestOptions} from '../core/services/http.service';

export class PreferDriverDataSource<T> extends DataSource<T> {
    protected apiPath: string = '/gt/gt-api/cl/preferDrivers';

    async list(options?: IHttpRequestOptions): Promise<T[]> {
        return httpService.get(this.apiPath, options).then((response: any) => {
            return setMetadata(
                response.data.rows.map((v: any) => fromJson(this.recordClass, v)),
                fromJson(RestResponseRecord, response.data)
            );
        });
    }
}
